export const ACTIONS_TRUCK = {
  INVALIDATE: 'TRUCKS_INVALIDATE',
  RECEIVE: 'TRUCKS_RECEIVE',
  DELETE: 'TRUCK_DELETE',
  UPDATE: 'TRUCK_UPDATE',
};

const truckConstants = {};

export default truckConstants;
